(function () {
  function init() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;

    var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    if (!isDesktop || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.add('sl-revealed');
      }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sl-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    for (var j = 0; j < items.length; j++) {
      observer.observe(items[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* SL_ATC_WATCHDOG 15/10: "Plaats in winkelwagen" onder het product bleef op iPhone
   grijs (disabled) hangen terwijl de variant gewoon op voorraad is. Deze bewaking zet
   de knop weer aan zodra blijkt dat de gekozen variant beschikbaar is.
   Een uitverkochte variant blijft uitgeschakeld. */
(function () {
  if (window.SL_ATC_WATCHDOG) return;
  window.SL_ATC_WATCHDOG = true;
  var productCache = null;

  function mainBtn() {
    return document.querySelector('.product-information--inner [name="add"]') ||
      document.querySelector('.product-information--inner #AddToCart');
  }

  function variantAvailable(btn, cb) {
    var vs = document.querySelector('.product-information--inner variant-selects, .product-information--inner variant-radios');
    if (vs && vs.currentVariant) return cb(!!vs.currentVariant.available);
    var form = btn.form || btn.closest('form');
    var input = form && form.querySelector('[name="id"]');
    var id = input && String(input.value);
    if (!id) return cb(false);
    function check(p) {
      var v = p && p.variants && p.variants.filter(function (x) { return String(x.id) === id; })[0];
      cb(!!(v && v.available));
    }
    if (productCache) return check(productCache);
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return cb(false);
    fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache = p; check(p); })
      .catch(function () { cb(false); });
  }

  function repair() {
    var btn = mainBtn();
    if (!btn || !btn.disabled) return;
    if (btn.classList.contains('loading') && !btn._slStuck) return;
    variantAvailable(btn, function (ok) {
      if (!ok || !btn.disabled) return;
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
    });
  }

  var timer = null, stuckTimer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(repair, 2500);
    var btn = mainBtn();
    if (btn && btn.classList.contains('loading')) {
      clearTimeout(stuckTimer);
      stuckTimer = setTimeout(function () { btn._slStuck = true; repair(); btn._slStuck = false; }, 10000);
    }
  }

  function start() {
    var btn = mainBtn();
    if (!btn || btn.dataset.slWatch) return;
    btn.dataset.slWatch = '1';
    new MutationObserver(schedule).observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', start);
  window.addEventListener('pageshow', function () { start(); schedule(); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-information--inner')) schedule();
  }, true);
})();
